import PreAndPostOpsoActions from "../../prat_actions/preAndPostOpso/preAndPostOpsoActions";

const PreAndPostOpsoReducer = (
  state = { isPreAndPostOpsoLoading: false,preAndPostOpsoHasError:false,preAndPostOpso:[] },
  action
) => {
  switch (action.type) {
    case PreAndPostOpsoActions.PRE_AND_POST_OPSO_REQUEST:
      return {
        ...state,
        isPreAndPostOpsoLoading: true,
        preAndPostOpso:[],
        preAndPostOpsoHasError:false
      };
    case PreAndPostOpsoActions.PRE_AND_POST_OPSO_SUCCESSFUL:
      return {
        ...state,
        isPreAndPostOpsoLoading: false,
        preAndPostOpso: action.data.data,
        preAndPostOpsoHasError:false
      };
    case PreAndPostOpsoActions.PRE_AND_POST_OPSO_FAILED:
      return {
        ...state,
        errorMessage: {},
        isPreAndPostOpsoLoading: false,
        preAndPostOpso:[],
        preAndPostOpsoHasError:true
      };
    default:
      return {
        ...state
      };
    //   break;
  }
};

export default PreAndPostOpsoReducer;
